import { Component } from '@angular/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Capacitor } from '@capacitor/core';
import { AlertController, Platform } from '@ionic/angular';
import { StatusBar } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { PwaService } from './services/pwa.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private platformCapacitor: string;

  constructor(
    private alertController: AlertController,
    private platform: Platform,
    private pwaService: PwaService
  ) {
    this.platformCapacitor = Capacitor.getPlatform();
    if (Capacitor.isNativePlatform()) {
        this.platform.ready().then(async () => {
        try {
          // Esperar un poco para asegurar que el WebView esté completamente cargado
          setTimeout(async () => {
            // Habilitar Edge-to-Edge en Android
            if (this.platformCapacitor === 'android') {
              try {
                await EdgeToEdge.enable();
                console.log('EdgeToEdge habilitado correctamente');
              } catch (e) {
                console.warn('EdgeToEdge no disponible o ya habilitado:', e);
              }
            }

            // Configurar StatusBar
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.show();
            console.log('StatusBar configurado correctamente');
          }, 100);
        } catch (error) {
          console.error('Error configurando StatusBar:', error);
        }
      });
    }
    // Bloquear orientación en móviles
    if (this.platformCapacitor === 'android' || this.platformCapacitor === 'ios') {
      ScreenOrientation.lock({ orientation: 'portrait' });
    }

    // Suscribirse a eventos PWA (solo en plataforma web)
    this.initPwaListeners();
  }

  /**
   * Inicializa los listeners para eventos PWA
   */
  private initPwaListeners() {
    // Escuchar evento de prompt de instalación
    this.pwaService.installPrompt$.subscribe(() => {
      this.showPwaInstallPrompt();
    });

    // Escuchar evento de actualización disponible
    this.pwaService.updateAvailable$.subscribe(() => {
      this.showUpdateAlert();
    });
  }

  /**
   * Muestra el diálogo de actualización disponible
   */
  private async showUpdateAlert() {
    const alert = await this.alertController.create({
      header: '¡Nueva versión disponible!',
      message: 'Hay una nueva versión de la aplicación lista para usar. ¿Deseas actualizar ahora?',
      buttons: [
        {
          text: 'Ahora no',
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: 'Actualizar',
          cssClass: 'primary',
          handler: () => {
            this.pwaService.activateUpdate();
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * Muestra el diálogo de instalación PWA
   */
  private async showPwaInstallPrompt() {
    const alert = await this.alertController.create({
      header: '¡Instala nuestra app!',
      message: 'Instala Street Gym en tu dispositivo para un acceso más rápido y una mejor experiencia.',
      cssClass: 'pwa-install-alert',
      buttons: [
        {
          text: 'Ahora no',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.pwaService.dismissInstallPrompt();
          }
        },
        {
          text: 'Instalar',
          cssClass: 'primary',
          handler: async () => {
            const installed = await this.pwaService.promptInstall();
            if (installed) {
              console.log('PWA instalada exitosamente');
            }
          }
        }
      ]
    });

    await alert.present();
  }
}
